{
  "REPORT": {
    "HEADER": "Conversations",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_AGENT_REPORTS": "Download agent reports",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messages received",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messages sent",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Today",
      "YESTERDAY": "Yesterday",
      "LAST_7_DAYS": "Last 7 days",
      "LAST_30_DAYS": "Last 30 days",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "Last 3 months",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year",
      "CUSTOM_DATE_RANGE": "Custom date range"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Group By",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "Day",
      "WEEK": "Week",
      "MONTH": "Month",
      "YEAR": "Year"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      },
      {
        "id": 4,
        "groupBy": "Year"
      }
    ],
    "BUSINESS_HOURS": "Business Hours",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "No results found"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Conversations: {count}",
      "RESULT_COUNT_MESSAGE": "Messages: {count}",
      "EMPTY": "No records found for this bar.",
      "ERROR": "Could not load records. Please try again.",
      "LOAD_MORE": "Load more",
      "PREVIOUS_BUCKET": "Previous bar",
      "NEXT_BUCKET": "Next bar",
      "UNKNOWN_CONTACT": "Unknown contact",
      "UNKNOWN_INBOX": "Unknown inbox",
      "UNASSIGNED_AGENT": "Unassigned",
      "NO_MESSAGE_CONTENT": "No message content",
      "MESSAGE_CREATED_AT": "Message created at {time}",
      "EVENT_OCCURRED_AT": "Event occurred at {time}",
      "INCOMING_MESSAGE": "Incoming message",
      "OUTGOING_MESSAGE": "Outgoing message",
      "VIEW_ALL": "View in conversations",
      "VIEW_ALL_LIMIT": "Only bars with up to {limit} conversations open in the conversation list.",
      "HIDDEN_COUNT": "Not shown because you are not a member of their inbox: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agents Overview",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_AGENT_REPORTS": "Download agent reports",
    "FILTER_DROPDOWN_LABEL": "Select Agent",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Labels Overview",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_LABEL_REPORTS": "Download label reports",
    "FILTER_DROPDOWN_LABEL": "Select Label",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Inbox Overview",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_INBOX_REPORTS": "Download inbox reports",
    "FILTER_DROPDOWN_LABEL": "Select Inbox",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Overview",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_TEAM_REPORTS": "Download team reports",
    "FILTER_DROPDOWN_LABEL": "Select Team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reports",
    "NO_RECORDS": "There are no CSAT survey responses available.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Choose Agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Assigned agent",
        "RATING": "Rating",
        "FEEDBACK_TEXT": "Feedback comment"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total responses",
        "TOOLTIP": "Total number of responses collected"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Satisfaction score",
        "TOOLTIP": "Total number of positive responses / Total number of responses * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Response rate",
        "TOOLTIP": "Total number of responses / Total number of CSAT survey messages sent * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with bot messages"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Number of Answers",
        "TOOLTIP": "Total number of outgoing messages"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Number of AI Answers",
        "TOOLTIP": "Total number of answer messages sent by the bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Number of Prepared Responses",
        "TOOLTIP": "Total number of copilot suggestions prepared by the bot for agents"
      },
      "SUCCESS_RATE": {
        "LABEL": "Resolved by AI",
        "TOOLTIP": "Percentage of conversations resolved by AI without agent handoff"
      },
      "RESOLVE_TIME": {
        "LABEL": "Resolution Time",
        "TOOLTIP": "Median time from first customer message to last bot/agent message"
      }
    },
    "GROUP_BY": {
      "LABEL": "Group by",
      "NONE": "Do not group",
      "INBOXES": "Inboxes",
      "LABELS": "Labels"
    },
    "GROUPED": {
      "CHART_TITLE": "Distribution by group",
      "BACK_TO_ALL": "Show all",
      "TABLE": {
        "INBOX": "Inbox",
        "LABEL": "Label",
        "CONVERSATIONS": "Conversations",
        "MESSAGES": "Messages",
        "MESSAGES_TOOLTIP": "Total number of outgoing messages",
        "AI_MESSAGES": "AI Answers",
        "AI_MESSAGES_TOOLTIP": "Total number of AI answers, followed by the count of positive and negative end-user ratings",
        "THUMBS_UP_TOOLTIP": "Number of AI answers rated positive (thumbs up) by end-users",
        "THUMBS_DOWN_TOOLTIP": "Number of AI answers rated negative (thumbs down) by end-users",
        "AI_PERCENTAGE": "AI %",
        "AI_PERCENTAGE_TOOLTIP": "Percentage of AI answers from all messages in this group",
        "PREPARED": "Prepared Answers",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Percentage of messages from all messages belonging to this group",
        "BOT_RESPONSES": "AI Answers %",
        "SUGGESTION_USED": "Used Answers",
        "SUGGESTION_USED_TOOLTIP": "Percentage of prepared answers in this group that were used by agents",
        "SUGGESTION_NOT_USED": "Unused Answers",
        "SUGGESTION_NOT_USED_TOOLTIP": "Percentage of messages in this group that had a prepared response but it was not used"
      },
      "NOTES": {
        "TITLE": "How metrics are calculated",
        "CONVERSATIONS": "Number of conversations that have at least one outgoing message in the selected period.",
        "MESSAGES": "Total number of outgoing (non-private) messages sent in the selected period. This includes both AI-generated and human-written messages.",
        "PERCENTAGE": "Share of this group's messages out of all outgoing messages across all groups.",
        "AI_MESSAGES": "Number of outgoing messages sent automatically by the AI bot (not including prepared responses for agents). The numbers in parentheses show how many of those answers were rated positive (thumbs up) and negative (thumbs down) by end-users.",
        "BOT_RESPONSES_PCT": "Share of this group's AI answers out of all outgoing messages in this group.",
        "PREPARED": "Number of copilot suggestions (prepared responses) generated by the AI bot for agents in the selected period. These are private messages visible only to agents and are not counted as outgoing messages, so this number may not correlate with the Messages column.",
        "SUGGESTION_USED": "Percentage of prepared answers in this group that were used by agents. This may not correlate with the Prepared Answers count because it can also include suggestions generated in previous periods.",
        "SUGGESTION_NOT_USED": "Percentage of outgoing messages in this group where a copilot suggestion was available but the agent replied without using it. Only counted when the agent actually sent a reply. This may not correlate with the Prepared Answers count because it can also include suggestions generated in previous periods."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Overview",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "Open",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "Unassigned",
      "PENDING": "Pending"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Open",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Open",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "Online",
      "BUSY": "Busy",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "No results found",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent name",
        "INBOXES": "Inbox name",
        "LABELS": "Label name",
        "TEAMS": "Team name"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Inbox",
      "AGENTS": "Agent",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Conversation",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Inbox",
    "AGENT": "Agent",
    "TEAM": "Team",
    "LABEL": "Label",
    "TOTAL": "Total",
    "SUBTOTAL": "Subtotal",
    "NO_TEAM": "No team",
    "GROUP_BY_TEAMS": "Group by teams",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Resolution Count",
    "CONVERSATIONS": "No. of conversations",
    "OUTGOING_CHATS": "Outgoing chats",
    "OUTGOING_EMAILS": "Outgoing emails",
    "PHONE_CALLS": "Phone calls",
    "INBOUND_CALLS": "Inbound calls",
    "OUTBOUND_CALLS": "Outbound calls",
    "TOTAL_ACTIVITIES": "Total activities",
    "ONLINE_TIME": "Online time",
    "QUEUE_AVAILABLE_TIME": "Queue available time",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Number of outgoing messages sent by this agent",
      "OUTGOING_EMAILS": "Number of outgoing emails sent by this agent",
      "PHONE_CALLS": "Total number of phone calls assigned to this agent (sum of inbound and outbound calls)",
      "TOTAL_ACTIVITIES": "Total number of activities: inbound calls + outbound calls + outgoing chats + outgoing emails",
      "INBOUND_CALLS": "Number of inbound phone calls assigned to this agent",
      "OUTBOUND_CALLS": "Number of outbound phone calls assigned to this agent",
      "AVG_FIRST_RESPONSE_TIME": "Average time from conversation creation to first agent response in conversations assigned to this agent",
      "AVG_RESOLUTION_TIME": "Average time from conversation creation to resolution in conversations assigned to this agent",
      "AVG_REPLY_TIME": "Average time customers wait between their message and agent's reply in conversations assigned to this agent",
      "ONLINE_TIME": "Total time the agent was online or busy during the selected period",
      "QUEUE_AVAILABLE_TIME": "Total time the agent was available in phone queues during the selected period"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Phone Reports",
    "DESCRIPTION": "Track phone call metrics with detailed insights on inbound and outbound calls, grouped by agent or inbox for comprehensive analysis.",
    "AGENT_HEADER": "Phone Reports - By Agent",
    "INBOX_HEADER": "Phone Reports - By Inbox",
    "DOWNLOAD_BUTTON": "Download Phone Reports",
    "DOWNLOAD_PHONE_REPORTS": "Download Phone Reports",
    "GROUP_BY": {
      "LABEL": "Group By",
      "AGENT": "Agent",
      "INBOX": "Inbox"
    },
    "TABLE": {
      "AGENT_NAME": "Agent Name",
      "INBOX_NAME": "Inbox Name",
      "TOTAL_CALLS": "Total",
      "INBOUND_CALLS": "Inbound",
      "OUTBOUND_CALLS": "Outbound",
      "FAILED_OUTBOUND_CALLS": "Failed outbound",
      "AVG_AGENT_HANDLED_DURATION": "Avg Duration",
      "TOTAL_AGENT_HANDLED_DURATION": "Total Duration",
      "AVG_RINGING_TIME": "Avg Ring Time",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Success %",
      "UNIQUE_CALLERS": "Unique Callers",
      "UNIQUE_CALLED_CONTACTS": "Unique Called",
      "UNANSWERED_MISSED_CALLS": "Missed no followup",
      "UNANSWERED_MISSED_PERCENTAGE": "Unaswered missed %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Missed no followup, insufficiently called back",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Missed no followup, insufficiently called back %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Total number of all calls (including unconnected)",
      "INBOUND_CALLS": "Number of connected calls",
      "OUTBOUND_CALLS": "Number of all outbound calls (including unconnected)",
      "FAILED_OUTBOUND_CALLS": "Number of outbound calls that failed to connect",
      "AVG_AGENT_HANDLED_DURATION": "Average duration of calls handled by agents",
      "TOTAL_AGENT_HANDLED_DURATION": "Total duration of all calls handled by agents",
      "AVG_RINGING_TIME": "Average time calls spent ringing before being answered",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Percentage of outbound calls that were successfully connected",
      "UNIQUE_CALLERS": "Number of unique contacts who made inbound calls",
      "UNIQUE_CALLED_CONTACTS": "Number of unique contacts who were called via outbound calls",
      "UNANSWERED_MISSED_CALLS": "Number of missed calls where no successful callback was made (call connected). May include calls that can still be handled within the business day",
      "UNANSWERED_MISSED_PERCENTAGE": "Percentage of unique callers whose calls were missed without followup (unanswered missed calls / unique callers)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Number of missed calls with less than 2 callback attempts. May include calls that can still be handled within the business day",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Percentage of unique callers with less than 2 callback attempts ((missed no followup - sufficiently handled) / unique callers)"
    },
    "EMPTY_STATE": {
      "TITLE": "No phone call data available",
      "MESSAGE": "There are no phone calls in the selected date range. Try adjusting your filters or date range."
    }
  }
}
